module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vback10-20636fc3f572d7311c3427ee72b80ba7.jpg";